import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxFiltersService} from "./ngx-filters.service";
import {NgxFilterConfig} from "./ngx-filter-config";
import {NgxFiltersComponent} from "./ngx-filters.component";
import {SelectBoxComponent} from "./components/select/select-box/select-box.component";
import {NgxNumberFilterComponent} from "./components/number-box/ngx-number-filter/ngx-number-filter.component";
import {FormsModule} from "@angular/forms";
import {NgxTrueFalseFilterComponent} from "./components/true-false/ngx-true-false-filter/ngx-true-false-filter.component";
import {NumberBoxComponent} from "./components/number-box/number-box.component";
import {DateComponent} from "./components/date/date.component";
import {TextBoxComponent} from "./components/text-box/text-box.component";
import {NgxDateFilterComponent} from "./components/date/ngx-date-filter/ngx-date-filter.component";
import {NgxTextFilterComponent} from "./components/text-box/ngx-text-filter/ngx-text-filter.component";
import {TrueFalseComponent} from "./components/true-false/true-false.component";
import {NgxMultiSelectFilterComponent} from "./components/select/multi-select-box/ngx-multi-select/ngx-multi-select-filter.component";
import {MultiSelectBoxComponent} from "./components/select/multi-select-box/multi-select-box.component";
import {NgxSelectFilterComponent} from "./components/select/select-box/ngx-select-filter/ngx-select-filter.component";
import {ConditionsSelectorComponent} from "./components/conditions-selector/conditions-selector.component";
import {SeparateThreeCommaPipe} from "./pipes/separate-three-comma.pipe";
import {ConditionFilterPipe} from "./pipes/condition-filter.pipe";
import {DisplayLabelFilterPipe} from "./pipes/display-label-filter.pipe";
import {HasFilterPipe} from "./pipes/has-filter.pipe";
import {NgxConditionsSelectorFilterComponent} from './components/conditions-selector/ngx-conditions-selector-filter/ngx-conditions-selector-filter.component';
import {NgxChipFilterComponent} from './ngx-chip-filter/ngx-chip-filter.component';
import {NGX_FILTERS_CONFIGS} from "./ngx-filters-token";
import {RemoveEnterPipe} from "./pipes/remove-enter.pipe";


@NgModule({
  declarations: [
    NgxFiltersComponent,
    ConditionsSelectorComponent,
    TextBoxComponent,
    NumberBoxComponent,
    DateComponent,
    SelectBoxComponent,
    MultiSelectBoxComponent,
    TrueFalseComponent,
    NgxDateFilterComponent,
    NgxTextFilterComponent,
    NgxNumberFilterComponent,
    SeparateThreeCommaPipe,
    NgxSelectFilterComponent,
    NgxMultiSelectFilterComponent,
    NgxTrueFalseFilterComponent,
    ConditionFilterPipe,
    DisplayLabelFilterPipe,
    HasFilterPipe,
    NgxConditionsSelectorFilterComponent,
    NgxChipFilterComponent,
    RemoveEnterPipe
  ],
  exports: [
    NgxFiltersComponent,
    ConditionsSelectorComponent,
    TextBoxComponent,
    NumberBoxComponent,
    DateComponent,
    SelectBoxComponent,
    MultiSelectBoxComponent,
    TrueFalseComponent,
    NgxDateFilterComponent,
    NgxTextFilterComponent,
    NgxNumberFilterComponent,
    SeparateThreeCommaPipe,
    NgxConditionsSelectorFilterComponent,
    NgxChipFilterComponent,
    RemoveEnterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  providers: []
})
export class NgxFiltersModule {
  public static forRoot(configs?: NgxFilterConfig): ModuleWithProviders<NgxFiltersModule> {
    if (configs) {
      return {
        ngModule: NgxFiltersModule,
        providers: [
          {provide: NGX_FILTERS_CONFIGS, useValue: configs},
          NgxFiltersService,
        ]
      }
    }
  }
}

